import { usersManagementApi } from 'app/services/api';

const uploaderNameRequests = new Map();

const toFullName = ({ firstName, lastName }) =>
  [firstName, lastName].filter(Boolean).join(' ') || null;

// A title-portal uploader is an external user, absent from the employee list the users store holds, so
// each one is fetched on its own, once per session.
export const fetchUploaderName = ({ companyId, userId }) => {
  if (!uploaderNameRequests.has(userId)) {
    const request = usersManagementApi
      .getUser({ companyId, id: userId })
      .then(({ data }) => toFullName(data))
      .catch(() => {
        uploaderNameRequests.delete(userId);

        return null;
      });

    uploaderNameRequests.set(userId, request);
  }

  return uploaderNameRequests.get(userId);
};
